export default __webpack_public_path__ + "static/cell-biochip-1.external-d5abde80654661630a81511c1ed10edf.svg";